var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"color":"purple","small":""},domProps:{"innerHTML":_vm._s('mdi-clipboard-text-clock')},on:{"click":_vm.showLastLogs}},'v-icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }